import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import BeneficiaryDesignationStatus from './BeneficiaryDesignationStatus';

const propTypes = {
    apiUrl: PropTypes.string.isRequired
};

class BeneficiaryDesignationStatusContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            complete: null,
            pending: null,
            name: null,
            dataLoaded: false
        };

        this.getData = this.getData.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        let { apiUrl } = this.props;
        axios.get(apiUrl).then(response => {
            const data = {
                completed: !!response.data.currentBeneficiaryDesignationDate,
                completedDate: new Date(response.data.currentBeneficiaryDesignationDate),
                pending: !!response.data.pendingBeneficiaryDesignationDate,
                pendingDate: new Date(response.data.pendingBeneficiaryDesignationDate),
                name: response.data.name
            };
            this.setState({
                data,
                dataLoaded: true
            });
        });
    }

    render() {
        let { dataLoaded, data } = this.state;

        return (
            <>
                {!dataLoaded && (
                    <div className="asc-skeleton-holder">
                        <p
                            className="asc-skeleton"
                            style={{ width: '116px', height: '16px', display: 'block' }}
                        />
                        <div
                            className="asc-h1 asc-skeleton"
                            style={{
                                width: '242px',
                                height: '22px',
                                display: 'block',
                                margin: '15px 0'
                            }}
                        >
                            <span className="asc-acc-hidden">Loading...</span>
                        </div>
                        <p
                            className="asc-skeleton"
                            style={{
                                width: '116px',
                                height: '16px',
                                display: 'block',
                                marginTop: '15px'
                            }}
                        />
                        <p
                            className="asc-skeleton"
                            style={{
                                width: '200px',
                                height: '22px',
                                display: 'block',
                                margin: '15px 0'
                            }}
                        />
                    </div>
                )}

                {dataLoaded && <BeneficiaryDesignationStatus data={data} />}
            </>
        );
    }
}
BeneficiaryDesignationStatusContainer.propTypes = propTypes;
export default BeneficiaryDesignationStatusContainer;
